export const useProseClasses = () => {
    // Standard prose classes for wysiwyg content
    const proseClasses = 'prose text-[15px] prose-ul:list-disc prose-ol:list-decimal prose-li:my-1 prose-p:my-0 prose-p:mb-2 prose-headings:font-bold prose-h1:text-[1.75rem] prose-h2:text-[1.5rem] prose-h3:text-[1.25rem] prose-a:text-primary prose-a:underline hover:prose-a:no-underline';
    
    return {
        proseClasses
    };
};